<script lang="ts">
	//Design System components
	import { Container } from '@Shelly/shelly-design-system';
	//Helpers
	import { _deepClone } from '../../../../helpers/utilities';
	//Types
	import type { IAlarmZone } from '../alarm_object';
	//Components
	import AlarmBreachedSensor from 'src/components/Lists/Alarms/components/AlarmBreachedSensor.svelte';

	export let alarm: IAlarmZone = {};
</script>

<Container padding="scrollPaddings">
	<AlarmBreachedSensor {alarm} listenAlarmChange={true} showItemsActBtn={false} />
</Container>
